import {
  FamilyApplicationResp,
  GetTaxCommissionIncomeDetailsResp,
} from '@/apis/family_application/requests'
import { useTranslation } from 'react-i18next'

interface Props {
  application: FamilyApplicationResp
  taxCommissionInfo: GetTaxCommissionIncomeDetailsResp | null
}

function TaxCommissionSummary(props: Props) {
  const { application, taxCommissionInfo } = props
  const { t } = useTranslation()

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    currency: 'USD',
  })

  if (application.income_evaluated_by !== 'tax_commission' || !taxCommissionInfo) {
    return null
  }


  return taxCommissionInfo.map((taxCommissionInfo) => {
    return (
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <div className="font-normal text-gray-800">
            {t('feed_adjusted_gross_income')}
          </div>
          <div className="text-gray-700  text-sm font-medium">
            {currencyFormatter.format(taxCommissionInfo.FedAdjustedGrossIncome)}
          </div>
        </div>
        <div className="flex items-center justify-between">
          <div className="font-normal text-gray-800">{t('income_tax_year')}</div>
          <div className="text-gray-700  text-sm font-medium">
            {taxCommissionInfo.IncomeTaxYear}
          </div>
        </div>
      </div>
    )

  })
}

export default TaxCommissionSummary
